module.exports = __webpack_public_path__ + "static/media/18.6d852b3b.jpg";